import type { ContactModel } from '@src/service/model/contact/ContactModel'

import Repository from './base'

export class ContactRepository extends Repository<ContactModel> {
  private fastForward(lastItem: ContactModel) {
    let fastForwardComplete = false
    return (item: ContactModel) => {
      if (fastForwardComplete) {
        return true
      }
      if (item.id === lastItem.id) {
        fastForwardComplete = true
      }
      return false
    }
  }

  async paginated(
    params: { lastId?: string; limit?: number } = {},
  ): Promise<ContactModel[]> {
    const limit = params.limit ?? 1000
    const item = params.lastId ? await this.table.get(params.lastId) : null

    if (item) {
      return this.table
        .where('sortName')
        .aboveOrEqual(item.sortName)
        .filter(this.fastForward(item))
        .limit(limit)
        .toArray()
    }

    return this.table.orderBy('sortName').limit(limit).toArray()
  }

  getUniqueSources(): Promise<[string, string, string][]> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- FIXME: Fix this ESLint violation!
    return this.table.orderBy('[source+sourceName+userId]').uniqueKeys() as any
  }

  getByPhoneNumbers(phoneNumbers: string[]): Promise<ContactModel[]> {
    return this.table.where('_phoneNumbers').anyOf(phoneNumbers).distinct().toArray()
  }

  async deleteFromPublicApi() {
    await this.table.filter((contact) => contact.fromPublicApi).delete()
  }
}
